import React from 'react';
import './advanced-protection-status.scss';

export const AdvancedProtectionStatus: React.FC<{ value: string }> = ({ value }) => (
    <div className={`cell value ${value}`}>{value}</div>
);
